import { Link } from "../router";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";
import { BACKEND_ENABLED } from "../config";

export function HomePage() {
  const { session } = useAuth();
  const { t } = useLang();

  return (
    <div className="page home">
      <section className="hero">
        <h1 className="hero-title">{t.homeTitle}</h1>
        <p className="hero-sub">
          {t.homeSubDocsFaq}
          {BACKEND_ENABLED ? t.homeSubDownloads : ""}.
        </p>
        {BACKEND_ENABLED &&
          (session ? (
            <p className="hero-greeting muted">
              {t.homeSignedInAs} <strong>{session.email}</strong>
            </p>
          ) : (
            <p className="hero-greeting muted">
              {t.homeSignInPrompt}
              <Link to="/login" className="muted-link">
                {t.homeSignInLink}
              </Link>
              {t.homeSignInPromptAfter}
            </p>
          ))}
      </section>

      <section className="card-grid">
        <Link to="/docs" className="feature-card">
          <div className="feature-icon" aria-hidden="true">
            📚
          </div>
          <h3>{t.cardDocsTitle}</h3>
          <p className="muted">{t.cardDocsDesc}</p>
          <span className="feature-cta">{t.cardDocsCta}</span>
        </Link>

        <Link to="/faq" className="feature-card">
          <div className="feature-icon" aria-hidden="true">
            💬
          </div>
          <h3>{t.cardFaqTitle}</h3>
          <p className="muted">{t.cardFaqDesc}</p>
          <span className="feature-cta">{t.cardFaqCta}</span>
        </Link>

        {BACKEND_ENABLED && (
          <Link to="/downloads" className="feature-card">
            <div className="feature-icon" aria-hidden="true">
              ⬇️
            </div>
            <h3>{t.cardDownloadsTitle}</h3>
            <p className="muted">{t.cardDownloadsDesc}</p>
            <span className="feature-cta">{t.cardDownloadsCta}</span>
          </Link>
        )}
      </section>
    </div>
  );
}
